// The public application page's address — the website's "Apply" link points
// here. App.tsx checks it BEFORE the auth gate, so the page renders for
// anyone, signed in or not, with none of the MOS chrome around it.

export const APPLY_PATH = '/apply';

/** True on /apply (a trailing slash or capitals from a hand-typed link still land). */
export function isApplyPath(pathname: string): boolean {
  return /^\/apply\/?$/i.test(pathname);
}
